import Wybierz from "./Wybierz";
export default Wybierz;